import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

type Paged<T> = { items?: T[]; pagination?: { nextCursor?: string | null } }

async function fetchAllPages<T>(
  fetcher: (args: any) => Promise<{ data: any }>,
  baseArgs: Record<string, any>,
  limit = 100,
  safetyCap = 2000
): Promise<T[]> {
  let cursor: string | undefined = undefined
  const out: T[] = []
  for (;;) {
    const resp = await fetcher({ ...baseArgs, limit, cursor })
    const page = resp.data as Paged<T> | null | undefined
    if (page?.items?.length) {
      out.push(...page.items)
    }
    if (!page?.pagination?.nextCursor) break
    cursor = page.pagination.nextCursor || undefined
    if (out.length >= safetyCap) break
  }
  return out
}

export async function fetchAllForCustomer(args: {
  customerId: string
  from?: string
  to?: string
  currency?: string
}) {
  const { customerId, from, to, currency } = args

  const [schedules, invoices, journals] = await Promise.all([
    fetchAllPages(dashboard20240730Client.getBillingSchedules, {
      customerId
    }),
    fetchAllPages(dashboardv99990101Client.getInvoices, {
      customerId
    }),
    fetchAllPages(dashboardv99990101Client.getJournalsPaginated, {
      customerId,
      from,
      to,
      currency
    })
  ])

  return { schedules, invoices, journals }
}
